import { RevealOnScroll } from "./Reveal";
import { DOVE } from "@/constants/testIds";
import { SITE } from "@/data/siteData";
import { MapPin, ArrowUpRight } from "lucide-react";

const DoveSiamo = () => {
    return (
        <section
            id="dove"
            data-testid={DOVE.section}
            className="relative px-5 md:px-10 lg:px-14 max-w-[1600px] mx-auto py-20 md:py-28"
        >
            <div className="grid md:grid-cols-12 gap-8 md:gap-12">
                <div className="md:col-span-5 flex flex-col justify-between">
                    <div>
                        <span className="text-xs md:text-sm uppercase tracking-[0.3em] font-bold text-[#E63946]">
                            · Dove Siamo
                        </span>
                        <RevealOnScroll delay={0.1}>
                            <h2 className="font-display uppercase text-5xl md:text-7xl leading-[0.9] mt-3">
                                Nel cuore
                                <br />
                                di{" "}
                                <span className="italic font-serif-editorial text-[#E63946] normal-case">
                                    Castel d&apos;Ario.
                                </span>
                            </h2>
                        </RevealOnScroll>
                        <RevealOnScroll delay={0.2}>
                            <p className="mt-6 text-lg text-[#0a0a0a]/75 max-w-md">
                                Ci trovi lungo Via XX Settembre, a pochi passi dalla
                                piazza principale. Parcheggio libero nelle vicinanze.
                            </p>
                        </RevealOnScroll>
                    </div>

                    <RevealOnScroll delay={0.3}>
                        <div
                            data-testid={DOVE.address}
                            className="mt-10 md:mt-14 border-2 border-[#0a0a0a] bg-[#FFD600] p-6 md:p-8 hard-shadow-sm"
                        >
                            <div className="flex items-start gap-3">
                                <MapPin
                                    className="w-6 h-6 mt-1 shrink-0"
                                    strokeWidth={2.5}
                                />
                                <div>
                                    <p className="font-display uppercase text-2xl md:text-3xl leading-tight">
                                        {SITE.address}
                                    </p>
                                    <p className="mt-2 text-sm uppercase tracking-widest font-bold text-[#0a0a0a]/70">
                                        {SITE.addressNote}
                                    </p>
                                    <a
                                        href={SITE.mapLink}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="mt-4 inline-flex items-center gap-2 font-bold uppercase tracking-widest text-sm underline underline-offset-4"
                                    >
                                        Apri in Google Maps
                                        <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </RevealOnScroll>
                </div>

                <div className="md:col-span-7">
                    <RevealOnScroll>
                        <div
                            data-testid={DOVE.map}
                            className="relative border-2 border-[#0a0a0a] overflow-hidden aspect-[4/3] md:aspect-[16/12] shadow-[12px_12px_0_0_#0a0a0a]"
                        >
                            <iframe
                                title="Mappa Senso Unico"
                                src={SITE.mapEmbed}
                                className="w-full h-full grayscale contrast-125"
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                            <div className="absolute top-4 left-4 bg-[#E63946] text-white text-xs md:text-sm uppercase tracking-[0.3em] font-bold px-3 py-2 rounded-full border-2 border-[#0a0a0a]">
                                Castel d&apos;Ario · Mantova
                            </div>
                        </div>
                    </RevealOnScroll>
                </div>
            </div>
        </section>
    );
};

export default DoveSiamo;
